import * as axios from "axios";
import { AlertMessage } from "../types/AlertMessage";
import { getUserDetails } from "../components/auth/AuthProvider";

export default class Api {
  private _showAlert: (alert: AlertMessage) => void;

  constructor(showAlert: (alert: AlertMessage) => void) {
    this._showAlert = showAlert;
  }

  protected get showAlert() {
    return this._showAlert;
  }

  protected init() {
    const user = getUserDetails()
    
    const client = axios.default.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 31000,
      headers: {
        Accept: "application/json",
        'authorization': user ? `Bearer ${user.token}` : undefined,
      },
    });

    client.interceptors.response.use(
      (response) => response,
      (error) => {
        console.log(error.message);
        throw error;
      }
    );

    return client;
  }
}
